import { List, ListItem, Stack } from "@mui/material";
import { ContentForm } from "@cbex/data-access";
import { CustomTypographyComponent } from "@cbex/ui/text";
import { useTheme } from "@cbex/utils/theme";
import React from "react";

interface FormIndexCompomentProps {
  data: ContentForm;
  errorIndexes: string[];
  onSectionClicked: (sectionID: string) => void;
}

export const FormIndexCompoment = (props: FormIndexCompomentProps) => {
  const { data, onSectionClicked, errorIndexes } = props;
  const theme = useTheme();
  const [selectedIndexItem, setSelectedIndexItem] = React.useState<
    number | undefined
  >(0);
  const handleOnClick = (item: any) => {
    const getObjectIndex = data.uiSchema["ui:order"].findIndex(
      (itm: any) => itm === item
    );
    setSelectedIndexItem(getObjectIndex);

    onSectionClicked(item);
  };

  const handleActiveColour = (index: number): string =>
    index === selectedIndexItem
      ? theme.appPalette.primary[80]
      : theme.appColors.surfaceContainerLow;
  return (
    <Stack
      sx={{
        boxSizing: "border-box",
      }}
      bgcolor={theme.appColors.surfaceContainerLow}
      id="FormIndexCompoment"
    >
      <List sx={{ backgroundColor: theme.appColors.surfaceContainerLow, p: 2 }}>
        {/* @ts-ignore */}
        {data.uiSchema["ui:order"].map((item: any, index) => (
          <ListItem
            sx={{
              width: 215,
              cursor: "pointer",
              borderRadius: 50,
              backgroundColor: handleActiveColour(index),
              ":hover": {
                backgroundColor: theme.appPalette.primary[70],
                // color: theme.palette.secondary.dark,
              },
            }}
            onClick={() => handleOnClick(item)}
            key={index}
          >
            {data.formSchema.properties[item].title}
            {errorIndexes && errorIndexes.length > 0 && (
              <CustomTypographyComponent
                ml={1}
                color={errorIndexes.includes(item) ? theme.appColors.error : ""}
                fontSize={12}
              >
                {errorIndexes.includes(item) ? " (Errors)" : ""}
              </CustomTypographyComponent>
            )}
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

export default FormIndexCompoment;
